export default "<div class=\"standalone-form-container\">\n  <task-form task=\"task\" \n             standalone=\"standalone\">\n  </task-form>\n</div>";